import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hidden md:flex justify-between items-start mb-4" }
const _hoisted_2 = { class: "text-3xl font-bold text-blue-400 max-w-[70%] break-words" }
const _hoisted_3 = { class: "text-2xl font-bold text-green-400 bg-gray-700 p-2 rounded-md ml-3 min-w-[130px] text-right shadow-inner" }
const _hoisted_4 = { class: "md:hidden mb-4" }
const _hoisted_5 = { class: "text-2xl font-bold text-blue-400 break-words overflow-wrap-anywhere mb-3" }
const _hoisted_6 = { class: "text-xl font-bold text-green-400 bg-gray-700 p-2 rounded-md shadow-inner text-center max-w-fit" }
const _hoisted_7 = { class: "flex items-center mb-4" }
const _hoisted_8 = { class: "flex items-center px-3 py-1 bg-gray-700 rounded-full text-sm text-blue-400 break-words overflow-wrap-anywhere" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatPrice(_ctx.product.price)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.product.name), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatPrice(_ctx.product.price)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.product.category.parent)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.product.category.parent.name) + " > " + _toDisplayString(_ctx.product.category.name), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.product.category.name), 1))
      ])
    ])
  ]))
}